import { render } from "./CardTwentyFour.vue?vue&type=template&id=6d76b59c"
import script from "./CardTwentyFour.vue?vue&type=script&lang=js"
export * from "./CardTwentyFour.vue?vue&type=script&lang=js"

import "./CardTwentyFour.vue?vue&type=style&index=0&id=6d76b59c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__